import { render, staticRenderFns } from "./messageManagement.vue?vue&type=template&id=bc998992&scoped=true"
import script from "./messageManagement.vue?vue&type=script&lang=js"
export * from "./messageManagement.vue?vue&type=script&lang=js"
import style0 from "./messageManagement.vue?vue&type=style&index=0&id=bc998992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc998992",
  null
  
)

export default component.exports